export default __webpack_public_path__ + "static/media/slow_resolution.25ec2e57.svg";